// this data is used to contruct analytics data layer
import { Injectable } from '@angular/core';
import { TrackData } from '@rd/types/analytics.type';
import { Sitemap } from '@rd/types/sitemap.type';

// this is the default which is used as placeholder
// whitelabel will override this sitemap
const sitemap: Sitemap = {
  homepage: 'homepage',
  pointsActivity: 'pointsactivity',
  contactUs: 'contactUs',
  redeemCash: {
    checkout: 'redeemcash:details',
    review: 'redeemcash:review',
    success: 'redeemcash:confirmation',
  },
  transferConnect: {
    listing: 'transfer',
    checkout: 'transfer:details',
    review: 'transfer:review',
    success: 'transfer:confirmation',
  },
  giftCard: {
    listing: 'giftcard',
    checkout: 'giftcard:details',
    review: 'giftcard:review',
    success: 'giftcard:confirmation',
    manage: 'giftcard:manage',
  },
  offers: {
    listing: 'offers',
    details: 'offers:details',
  },
  campaigns: {
    listing: 'campaigns',
    details: 'campaigns:details',
  },
  order: {
    manage: 'order:manage',
  },
  merchandises: {
    listing: 'merchandises',
    details: 'merchandises:details',
  },
  everydaySpend: {
    checkout: 'everydayspend:details',
    review: 'everydayspend:review',
  },
};

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  protected isEnabled = false;
  sitemap = sitemap;

  constructor() {}

  track(trackData: TrackData): void {
    // this is an no-op function if a whitelabel does not set up analytics
    if (!this.isEnabled) {
      return;
    }

    if (!trackData.routeName) {
      return;
    }

    this.trackEvent(trackData);
  }

  // dump function should be implemented in whitelabel
  protected trackEvent(trackData: TrackData): void {}

  // some analytics requires us execute a fuction after the script is loaded
  // dump function should be implemented in whitelabel
  protected onAnalyticsScriptLoaded(): void {}

  injectAnalyticsScript(): void {}
}
